// src/utils/userPreferences.js
export function getCurrentLanguage() {
  return localStorage.getItem("mercadito_lang") || "en";
}
